import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./StepUnit/Main";
import Form from "./StepUnit/Form";

// Utils
import { getData, getAlert } from "../../../utils/SamuiUtils";

const StepUnit = () => {
  const location = useLocation();
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState({
    Unit_Id: 0,
    Unit_Name: "",
    Unit_Status: "Y",
  });

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const compId = window.localStorage.getItem("company");
      const res = await getData(
        "Tb_Set_Unit",
        `${compId ? `Comp_Id = ${compId} AND ` : ""}1=1 ORDER BY Unit_Name`
      );
      const list = Array.isArray(res)
        ? res
        : Array.isArray(res?.data)
          ? res.data
          : [];
      setDataMasterList(list);
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
    setFormData({
      Unit_Id: 0,
      Unit_Name: "",
      Unit_Status: "Y",
    });
    setSelectedData(null);
  };

  const onRowSelected = (item) => {
    setMode("U");
    setFormData({
      Unit_Id: item.Unit_Id,
      Unit_Name: item.Unit_Name || "",
      Unit_Status: item.Unit_Status || "Y",
    });
    setSelectedData(item);
  };

  return (
    <div className="StepUnit">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"หน่วยขั้นตอนการบริการ"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                  fromServiceStep={location.state?.fromServiceStep}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"หน่วยขั้นตอนการบริการ"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepUnit;

